import React, { FC, useCallback, useState } from 'react';
import { Form } from '../../../../../Components/Form';
import { useIntl } from 'react-intl';
import { AptorApi } from '../../../../../Api/AptorApi';
import { useAptorApi } from '../../../../../Api';
import { entityToSelectOption } from '../../../../../Utilities';
import { useFormField } from '../../../../../Components/Form/FormField';
import { FormValues, SelectOption } from '../../../../../Components/Form/Form.types';
import { EditablePanel, HtmlForm, HtmlView } from '../../../../../Components';
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Grid, IconButton, Tooltip } from '@material-ui/core';
import { Title } from '../../../../../Components/Panel/Panel';
import { Block, Delete, Edit, ExpandMore, SyncSharp } from '@material-ui/icons';

interface IProps {
  submit: (
    form: FormValues,
    api: AptorApi,
    onSuccess: (successMessage?: string | undefined | null) => void,
  ) => Promise<void>;
  visible?: SelectOption[];
  initialData?: any;
}

interface ApplicationData {
  heading: string;
  application: string;
}

interface IconProps {
  id: number;
  name: string;
  icon?: React.ReactNode;
  onClick?: (event: any, lawData?: any) => void;
}

export const CreateInformationBoardForm: FC<IProps> = ({ submit, visible, initialData }) => {
  const { formatMessage } = useIntl();

  const onSubmit = (form: FormValues, api: AptorApi, onSuccess: (successMessage?: string | undefined | null) => void) =>
    submit({ ...form }, api, onSuccess);

  const name = useFormField({
    label: formatMessage({ id: 'admin.law-portal.informationBoard.form.name.label', defaultMessage: 'Headline' }),
    name: 'headline',
    type: 'text',
    required: true,
    initialState: initialData ? { value: initialData.headline, label: initialData.headline, isValid: true } : undefined,
  });

  const url = useFormField({
    label: formatMessage({ id: 'admin.law-portal.informationboard.form.url.label', defaultMessage: 'Url' }),
    name: 'url',
    type: 'text',
    required: true,
    initialState: initialData ? { value: initialData.url, label: initialData.url, isValid: true } : undefined,
  });

  const urlName = useFormField({
    label: formatMessage({ id: 'admin.law-portal.informationboard.form.urlName.label', defaultMessage: 'Name of link' }),
    name: 'urlName',
    type: 'text',
    placeholder: formatMessage({
      id: 'admin.law-portal.informationboard.form.urlName.placeholder',
      defaultMessage: 'Read the message in its entirety',
    }),
    required: false,
    initialState: initialData?.urlName ? { value: initialData.urlName, label: initialData.urlName, isValid: true } : undefined,
  });

  const chapter = useFormField({
    label: formatMessage({ id: 'admin.law-portal.informationBoard.form.message.label', defaultMessage: 'Message' }),
    name: 'message',
    type: 'rich-text',
    required: true,
    richTextEditorHeight: 'small',
    initialState: initialData ? { value: initialData.message, label: initialData.message, isValid: true } : undefined,
  });

  const visibleField = useFormField({
    label: formatMessage({ id: 'admin.law-portal.informationboard.form.visible.label', defaultMessage: 'Visible' }),
    name: 'visibleTo',
    type: 'single-select',
    options: visible,
    initialState: initialData && visible ? visible.find(v => v.value === initialData.visibleTo) : visible ? visible[2] : undefined,
    required: true,
  });




  return (
    <Form
      submit={onSubmit}
      groups={[
        {
          grid: {
            type: 'column',
            items: [
              name,
              chapter,
              {
                type: 'row',
                items: [ url,urlName,visibleField],
              },
            ],
          },
        },
      ]}
    />
  );
};